module.exports = __webpack_public_path__ + "static/content_1_do-c7de5011c4085e58fc02114d58950195.png";